import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify"; // ✅ Usar react-hot-toast

export const useCliente = () => {
   const queryClient = useQueryClient();
   const token = localStorage.getItem("token");
   const baseUrl = process.env.REACT_APP_URL_DIR + "cliente";

   const GetClientes = () => {
      const { data } = useQuery({
         queryKey: ["clientes"], // ✅ Plural
         retry: (failureCount, error) => {
            if (error?.message === "UNAUTHORIZED") return false;
            return failureCount < 2;
         },
         queryFn: async () => {
            const response = await fetch(baseUrl, {
               headers: {
                  Authorization: `Bearer ${token}`,
               },
            });
            if (response.status === 401) {
               toast.error("Tu sesión expiró. Iniciá sesión nuevamente.");
               localStorage.removeItem("token");
               setTimeout(() => {
                  window.location.href = "/login";
               }, 800);
               throw new Error("UNAUTHORIZED");
            }
            if (!response.ok) {
               throw new Error("Error fetching clientes");
            }
            return response.json();
         },
      });
      return data;
   };

   const DeleteCliente = useMutation({
      mutationFn: async (id) => {
         const response = await fetch(`${baseUrl}/${id}`, { 
            method: "DELETE",
            headers: {
               Authorization: `Bearer ${token}`,
            },
         });
         if (!response.ok) {
            throw new Error("Error deleting cliente");
         }
         queryClient.invalidateQueries(["clientes"]);
         return response.json();
      },
   });

   const SaveCliente = useMutation({
      mutationFn: async (clienteData) => {
         console.log("SaveCliente: ", clienteData);
         // si tiene -1 es pórque viene de Contratos y tengo que buscar el cliente por documento
         // para obtener el id_primary correcto
         if (clienteData.id_primary === -1) {  
            const doc = clienteData.documento;
            const responseCli = await fetch(
               `${baseUrl}/${doc}`,
               {
                  headers: {
                     Authorization: `Bearer ${token}`,
                  },
               }
            );
            if (responseCli.ok) {
               const cliente = await responseCli.json();
               clienteData.id_primary = cliente.id_primary;
            } else {
               clienteData.id_primary = 0;
            }  
         }

         const isUpdate = clienteData.id_primary > 0;
         const method = isUpdate ? "PUT" : "POST";
         const url = isUpdate
            ? `${baseUrl}/${clienteData.id_primary}`
            : `${baseUrl}`;

         const response = await fetch(url, {
            method,
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
            body: JSON.stringify(clienteData),
         });

         if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));

            let errorMessage = "Error desconocido";
            if (errorData.errors && Array.isArray(errorData.errors)) {
               errorMessage = errorData.errors.map((err) => err.msg).join(", ");
            } else if (errorData.message) {
               errorMessage = errorData.message;
            }

            throw new Error(errorMessage);
         }

         return response.json();
      },
      onSuccess: (data, variables) => {
         // ✅ Invalidar queries correctas
         queryClient.invalidateQueries({ queryKey: ["clientes"] });

         if (variables.id_primary > 0) {
            queryClient.invalidateQueries({
               queryKey: ["cliente", variables.id_primary],
            });
         }

         const isUpdate = variables.id_primary > 0;
         toast.success(
            isUpdate
               ? "Cliente actualizado exitosamente"
               : "Cliente creado exitosamente",
            {
               autoClose: 2000,
            }
         );
      },
      onError: (error) => {
         console.error("Error saving cliente:", error);
         toast.error(`Error al guardar.\n${error.message}`);
      },
   });

   return { GetClientes, SaveCliente, DeleteCliente };
};
